import React, { FC, Children, ReactElement, ReactNode } from "react";

interface Props {
  children: ReactNode;
  value: unknown;
}

interface OnProps {
  value?: unknown;
  children: ReactElement;
  anyOf?: unknown[];
  valueBetween?: [number, number];
}

export const On: FC<OnProps> = ({ children }) => <>{children}</>;

export const Other: FC<{ children: ReactNode }> = ({ children }) => (
  <>{children}</>
);

export const Match: FC<Props> = ({ children, value }) => {
  let match: ReactElement;
  let other: ReactElement;

  Children.forEach(children, (child: ReactElement) => {
    if (child.type !== On && child.type !== Other) {
      throw new Error("<Match> can only contain <On> or <Other> children");
    }

    const {
      props: { value: childValue, anyOf, valueBetween },
      type,
    } = child;

    if (type === Other) {
      other = child;
    }

    const valueIsMatch =
      childValue === value ||
      (anyOf && anyOf.includes(value)) ||
      (valueBetween &&
        Number(valueBetween[0]) <= Number(value) &&
        Number(valueBetween[1]) >= Number(value));

    if (valueIsMatch) {
      match = child;
    }
  });

  return match || other || null;
};
